import { createContext, useContext } from "react";

import { IPaginatedTableContext } from "./types";

export const PaginationTableContext = createContext({} as IPaginatedTableContext);

export function usePaginationTableContext() {
  const context = useContext(PaginationTableContext);

  if (!context) {
    throw new Error("usePaginationTableContext must be inside PaginationTableProvider");
  }

  return context;
}
